(function () {
  'use strict';

  angular.module('app').component('providerCreditNotePage', providerCreditNoteDetailCtrl());

  function providerCreditNoteDetailCtrl() {
    return {
      bindings: {},
      controller: ProviderCreditNoteDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/provider-credit-notes/provider-credit-note-page.component.html',
    };
  }

  ProviderCreditNoteDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'ProviderCreditNoteService',
  ];

  function ProviderCreditNoteDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    ProviderCreditNoteService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_providercreditnote_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    // Methods
    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        //edit
        vm.loadingItem = true;
        ProviderCreditNoteService.getProviderCreditNote(itemId).then(function (data) {
          vm.providerCreditNote = data;

          vm.loadingItem = false;
        });
      } else {
        vm.providerCreditNote = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/provider_credit_notes/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/provider_credit_notes');
    }
  }
})();
